'use client'

import { ImageHelper } from '@/lib/helpers/image.helper'
import { formatPrice } from '@/lib/utils'
import { Trash2 } from 'lucide-react'
import Image from 'next/image'
import { ConfirmProductItem } from './campaign-register-confirm'

interface CampaignProductSummaryListProps {
  title: string
  items: readonly ConfirmProductItem[]
  // Chỉ truyền ở màn chọn sản phẩm - hiện icon xoá trên mỗi dòng, gọi kèm
  // rowId để xoá đúng tổ hợp màu/size (item.rowId phải có giá trị).
  onRemove?: (item: ConfirmProductItem) => void
  removeAriaLabel?: string
}

// Bảng tóm tắt sản phẩm (header primary + hàng ảnh/tên/màu-size/giá) - dùng
// chung cho màn chọn sản phẩm (có thể xoá), màn xác nhận đăng ký và màn
// đăng ký thành công (chỉ xem).
export const CampaignProductSummaryList = ({
  title,
  items,
  onRemove,
  removeAriaLabel,
}: CampaignProductSummaryListProps) => {
  return (
    <div className='overflow-hidden rounded-lg bg-neutral-50'>
      <div className='flex h-12 items-center bg-primary-500 px-3 md:h-14'>
        <p className='font-criteria text-sm text-white md:text-base'>{title}</p>
      </div>
      <div className='flex flex-col gap-2 p-2 md:p-3'>
        {items.map((item, idx) => (
          <div key={item.rowId ?? `${item.productId}-${item.color}-${item.size}-${idx}`}>
            <div className='flex items-center gap-3 rounded-lg bg-white p-2 md:p-3'>
              <div className='relative aspect-[3/4] w-[72px] shrink-0 overflow-hidden rounded bg-gray-200 md:w-[90px]'>
                <Image
                  src={ImageHelper.getN7ImageUrl(item.image)}
                  alt={item.name}
                  fill
                  className='object-cover'
                />
              </div>
              <div className='min-w-0 flex-1 text-right'>
                <p className='truncate text-sm text-neutral-700'>{item.name}</p>
                <p className='mt-1 flex justify-end gap-2 text-xs text-neutral-400'>
                  <span>{item.color}</span>
                  <span>/</span>
                  <span>{item.size}</span>
                </p>
                <p className='mt-2 text-sm font-bold text-neutral-900'>
                  {formatPrice(item.price)}
                </p>
              </div>
              {onRemove && (
                <button
                  type='button'
                  aria-label={removeAriaLabel}
                  onClick={() => onRemove(item)}
                  className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700'
                >
                  <Trash2 size={16} />
                </button>
              )}
            </div>
            {idx < items.length - 1 && (
              <div className='mx-2 h-px bg-neutral-200 md:mx-3' />
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
